import { ChevronDown, ChevronRight } from 'react-feather';
import Colors from '../orderSections/Colors';

const OrderColorsSection = ({
	sections,
	toggleSection,
	onColorChange,
	selectedStyle,
	colors,
}) => {
	return (
		<div className="tab-information">
			<div className="tab-information-block">
				<div
					className="title-block"
					onClick={(e) => toggleSection('colorsTab', e)}
				>
					<h2 className="title-h2">Colors</h2>
					<button>
						{sections.colorsTab ? (
							<ChevronDown size={24} />
						) : (
							<ChevronRight size={24} />
						)}
					</button>
				</div>
				{sections.colorsTab && (
					<Colors
						onColorChange={onColorChange}
						selectedStyle={selectedStyle}
						colors={colors}
					/>
				)}
			</div>
		</div>
	);
};

export default OrderColorsSection;
